var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"complete"},[_vm._m(0),_vm._m(1),_c('div',{staticClass:"btn white",on:{"click":_vm.toRouter}},[_vm._v("返回首页")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('img',{attrs:{"src":require("./img/success.png"),"alt":""}}),_c('span',[_vm._v("您的申请已经提交成功~")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image"},[_c('img',{attrs:{"src":require("./img/complete.png"),"alt":""}})])
}]

export { render, staticRenderFns }